export const PRODUKTY  = 'produkty'
export const DOSTAWCY  = 'dostawcy'
export const OPCJE     = 'opcje'
export const KONKURSY  = 'konkursy'
export const UCZESTNIK = 'uczestnik'
export const TEST      = 'test'
export const PYTANIA   = 'pytania'
export const ODPOWIEDZ = 'odpowiedz'
export const REGULAMIN = 'regulamin'
export const START     = 'start'